import React from 'react';
import { Create } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const LocationRateSettingCreate = () => (
  <Create transform={getTransform(['agency_id', 'location_id'], 'settings')}>
    <RateSettingsForm settingsField="settings" />
  </Create>
);

export default LocationRateSettingCreate;
